import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const getLocaleFromCookie = () => {
  const match = document.cookie.match(/(^|;)\s*locale=([^;]*)/);
  return match ? decodeURIComponent(match[2]) : "en";
};

const getUrlHasThankYou = () => {
  if (typeof window === "undefined") return false;
  const params = new URLSearchParams(window.location.search);
  return params.get("thankyou") === "1" || params.get("status") === "submitted";
};

const ContactForm = ({ title, preTitle }) => {
  const { t } = useTranslation();
  const siteKey = "6Ld7pCErAAAAAN-Aw-ChxsmwXX6DiArl_xJuqLlK";
  const locale = getLocaleFromCookie();
  const [submitted, setSubmitted] = useState(getUrlHasThankYou());

  useEffect(() => {
    if (!submitted) {
      if (!window.MauticSDKLoaded) {
        window.MauticSDKLoaded = true;

        const mauticScript = document.createElement("script");
        mauticScript.src = "https://engage.lussana.me/media/js/mautic-form.js?va9981c41";
        mauticScript.crossOrigin = "anonymous";
        mauticScript.onload = () => window.MauticSDK?.onLoad?.();
        document.head.appendChild(mauticScript);

        const recaptchaScript = document.createElement("script");
        recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        recaptchaScript.async = true;
        recaptchaScript.defer = true;
        document.head.appendChild(recaptchaScript);
      }

      const trySetLocale = () => {
        const localeInput = document.getElementById("mauticform_input_contactme_locale");
        if (localeInput) {
          localeInput.value = locale;
        } else {
          setTimeout(trySetLocale, 200);
        }
      };

      trySetLocale();
    }
  }, [submitted, locale]);

  const handleSubmit = () => {
    const returnInput = document.getElementById("mauticform_contactme_return");
    if (returnInput) {
      returnInput.value = `${window.location.pathname}?thankyou=1`;
    }
  };

  return (
    <>
      <style>{`.mauticform-field-hidden { display: none; }`}</style>

      <div className="container">
        <div className="row mb-5 g-3 g-xl-5 align-items-end">
          <div className="col-lg-12">
            {submitted ? (
              <p style={{ lineHeight: "80%" }} className="mt-5">
                <span className="display-5" style={{ fontWeight: "bold", lineHeight: "50%" }}>
                  {t("contacts.thankYou")}
                </span>
              </p>
            ) : (
              <form
                autoComplete="off"
                role="form"
                method="post"
                action="https://engage.lussana.me/form/submit?formId=2"
                id="mauticform_contactme"
                data-mautic-form="contactme"
                encType="multipart/form-data"
                onSubmit={handleSubmit}
                className="row g-3 mt-4"
              >
                <div className="col-md-6">
                  <label className="form-label">{t("contacts.firstName")}</label>
                  <input
                    type="text"
                    name="mauticform[your_first_name]"
                    id="mauticform_input_contactme_your_first_name"
                    className="form-control"
                    placeholder={t("contacts.firstName")}
                    required
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">{t("contacts.lastName")}</label>
                  <input
                    type="text"
                    name="mauticform[your_last_name]"
                    id="mauticform_input_contactme_your_last_name"
                    className="form-control"
                    placeholder={t("contacts.lastName")}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">{t("contacts.emailAddress")}</label>
                  <input
                    type="email"
                    name="mauticform[your_email]"
                    id="mauticform_input_contactme_your_email"
                    className="form-control"
                    placeholder={t("contacts.emailAddress")}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">{t("contacts.subject")}</label>
                  <input
                    type="text"
                    name="mauticform[subject]"
                    id="mauticform_input_contactme_subject"
                    className="form-control"
                    placeholder={t("contacts.subject")}
                    required
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">{t("contacts.message")}</label>
                  <textarea
                    name="mauticform[f_message]"
                    id="mauticform_input_contactme_f_message"
                    className="form-control"
                    placeholder={t("contacts.message")}
                    required
                  ></textarea>
                </div>

                {/* Hidden Locale Field */}
                <input
                  type="hidden"
                  name="mauticform[locale]"
                  id="mauticform_input_contactme_locale"
                  value={locale}
                />

                {/* Newsletter Opt-in */}
                <div className="col-md-12">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="mauticform[newsletter][]"
                      value="optin"
                      id="mauticform_checkboxgrp_checkbox_newsletter_optin0"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="mauticform_checkboxgrp_checkbox_newsletter_optin0"
                    >
                      {t("contacts.optin")}
                    </label>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="col-md-12">
                  <button
                    type="submit"
                    className="btn btn-black w-100"
                    name="mauticform[submit]"
                    value="1"
                    id="mauticform_input_contactme_submit"
                    style={{ textTransform: "uppercase" }}
                  >
                    {t("contacts.submit")}
                  </button>
                </div>

                {/* Hidden Mautic Fields */}
                <input type="hidden" name="mauticform[formId]" value="2" />
                <input type="hidden" name="mauticform[return]" id="mauticform_contactme_return" value="" />
                <input type="hidden" name="mauticform[formName]" value="contactme" />

                {/* reCAPTCHA Notice */}
                <div className="col-12">
                  <p className="text-muted small mt-3">
                    {t("contacts.recaptchaNotice")}{" "}
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
                      {t("contacts.privacyPolicy")}
                    </a>{" "}
                    {t("contacts.and")}{" "}
                    <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
                      {t("contacts.termsOfService")}
                    </a>.
                  </p>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
